
  <wms-dialog-header title='{{isTemplateBundleType ? locale.LABEL_DIALOG_HEADER_ADD_TEMPLATE : (locale.LABEL_NEW + " " + locale[newPage?.label])}}'
             class="add-new-page-container-dialog large wm-studio-dialog"  helpLink="https://docs.wavemaker.com/learn/app-development/ui-design/page-concepts/page-templates/" closable="true" (onClose)="onClose()"></wms-dialog-header>

  <wms-dialog-body [ngClass]="baseScreen === 'templateContext' ? 'layout-dialog' : 'no-padding'">
    <wms-page-template [newPage]="newPage"
                       [isPrefabType]=" isPrefabType"
                       [template]="template"
                       [newPageTypes]="newPageTypes" [templateData]="templateData"
                       [stepCounter]="stepCounter"
                       [isTemplateBundleType]="isTemplateBundleType"
                       [tempCategory]="tempCategory"
                       [templatePlatformType]="templatePlatformType"
                       [selectedOrganization]="selectedOrganization"
                       [loadingTemplates]="loadingTemplates"
                       [preDefinedTemplates]="preDefinedTemplates"
                       [activeTemplate]="activeTemplate"
                       [preDefinedTemplateSelected]="preDefinedTemplateSelected"
                       [pageLayout]="pageLayout"
                       [ctrlScope]="ctrlScope"
                       [listImage]="listImage"
                       [propertyName]="propertyName"
                       [selectedWidget]="selectedWidget"
                       [fileAddMessage]="fileAddMessage"
                       [fields]="fields"
                       [createdVariable]="createdVariable"
                       [templateWidgets]="templateWidgets"
                       [baseScreen]="baseScreen"
                       [allTemplates]="allTemplates"
                       [selectedDataSource]="selectedDataSource"
                       [showTemplatePreview]="showTemplatePreview"
                       [isWeb]="isWeb" [isMobile]="isMobile" [templateType]="templateType"
                       (selectTemplate)="selectTemplate($event)"(importTemplateBundle)="importTemplateBundle($event)"
                       (previewTemplate)="previewTemplate($event)"
                       (onVariablePropertyChange)="onVariablePropertyChange($event)"
                       (changeNewPageType)="changeNewPageType($event)"
                       (setWidgetProp)="setWidgetProp($event)"
                       (getTemplates)="getTemplates($event)"
                       (selectTemplateWidget)="selectTemplateWidget($event)"
                       (getServiceEntitie)="getServiceEntitie($event)"
                       (clearServiceEntitie)="clearServiceEntitie()"

    ></wms-page-template>

  </wms-dialog-body>

    <wms-dialog-footer>
      <button type="button" name="btn-create-page" class="btn btn-primary" (click)="createNewPage('addNewPageDialog')" title="{{locale.LABEL_CREATE}}">
        <span class="btn-caption">{{locale.LABEL_CREATE}}</span>
      </button>
    </wms-dialog-footer>

